import React, { useState, useContext } from 'react';
import { Row, Col, Form, FormControl } from 'react-bootstrap';
import { ClassroomList } from '../../Context/ClassroomListContext';
import clientAxios from '../../clients/clientAxios';
import moment from 'moment';
import 'moment/locale/es';
import { notify } from 'react-notify-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faRedo,
  faUser,
  faEnvelope,
  faChalkboardTeacher,
  faCreditCard,
  faDollarSign,
  faCalendarAlt,
  faFilter,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';

const PAYMENT_METHODS = [
  'Efectivo',
  'Banco',
  'Tarjetas',
  'MercadoPago',
  'Paypal',
  'Payway',
  'Otro',
];

const Searchbox = ({
  defaultLastDays = 7,
  refresh,
  setResults,
  setIsDataLoading,
}) => {
  const { crList = [] } = useContext(ClassroomList) || {};

  const [filters, setFilters] = useState({
    student: '',
    email: '',
    classroom: '',
    payment: '',
    dateFrom: moment().subtract(defaultLastDays, 'days').format('YYYY-MM-DD'),
    dateTo: '',
    amount: 0,
  });
  const [isObtainingData, setIsObtainingData] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
    }
    setIsObtainingData(true);
    if (setIsDataLoading) {
      setIsDataLoading(true);
    }

    try {
      const response = await clientAxios.post('/bills/search/', filters);
      if (setResults) {
        setResults(response.data || []);
      }
    } catch (error) {
      notify.show(
        'No se pudieron obtener los datos, intente más tarde',
        'error'
      );
    } finally {
      setIsObtainingData(false);
      if (setIsDataLoading) {
        setIsDataLoading(false);
      }
    }
  };

  const handleClean = () => {
    setFilters({
      student: '',
      email: '',
      classroom: '',
      payment: '',
      dateFrom: '',
      dateTo: '',
      amount: 0,
    });
    if (refresh) {
      refresh();
    }
  };

  return (
    <div className='list-bill-search-card'>
      <div className='list-bill-search-title'>
        <span>
          <FontAwesomeIcon icon={faFilter} /> Filtros de Búsqueda
        </span>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row className='mb-3'>
          <Col lg={4} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faUser} className='mr-1' /> Alumno
            </label>
            <FormControl
              name='student'
              placeholder='Nombre o apellido del alumno...'
              value={filters.student}
              onChange={handleChange}
              className='modern-form-input w-100'
            />
          </Col>

          <Col lg={4} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faEnvelope} className='mr-1' /> Email
            </label>
            <FormControl
              name='email'
              placeholder='correo@ejemplo.com'
              value={filters.email}
              onChange={handleChange}
              className='modern-form-input w-100'
            />
          </Col>

          <Col lg={4} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faChalkboardTeacher} className='mr-1' /> Comisión
            </label>
            <FormControl
              name='classroom'
              placeholder='Todas las comisiones'
              value={filters.classroom}
              onChange={handleChange}
              list='classroom-options'
              autoComplete='off'
              className='modern-form-input w-100'
            />
            <datalist id='classroom-options'>
              {crList.map((item) => (
                <option
                  key={item.classroom || item._id}
                  value={item.classroom}
                />
              ))}
            </datalist>
          </Col>

          <Col lg={3} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faCreditCard} className='mr-1' /> Forma de Pago
            </label>
            <Form.Control
              as='select'
              value={filters.payment}
              name='payment'
              onChange={handleChange}
              className='modern-form-select w-100'
            >
              <option value=''>Todas las formas</option>
              {PAYMENT_METHODS.map((method) => (
                <option key={method} value={method}>
                  {method}
                </option>
              ))}
            </Form.Control>
          </Col>

          <Col lg={3} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faDollarSign} className='mr-1' /> Monto Mínimo ($)
            </label>
            <FormControl
              type='number'
              name='amount'
              placeholder='0'
              value={filters.amount === 0 ? '' : filters.amount}
              onChange={handleChange}
              className='modern-form-input w-100'
            />
          </Col>

          <Col lg={3} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faCalendarAlt} className='mr-1' /> Fecha Desde
            </label>
            <FormControl
              type='date'
              name='dateFrom'
              value={filters.dateFrom}
              onChange={handleChange}
              className='modern-form-input w-100'
            />
          </Col>

          <Col lg={3} md={6} sm={12} className='mb-3'>
            <label className='search-field-label'>
              <FontAwesomeIcon icon={faCalendarAlt} className='mr-1' /> Fecha Hasta
            </label>
            <FormControl
              type='date'
              name='dateTo'
              value={filters.dateTo}
              onChange={handleChange}
              className='modern-form-input w-100'
            />
          </Col>
        </Row>

        <Row className='d-flex justify-content-end align-items-center mt-2'>
          <Col xs={12} sm={6} md={3} lg={2} className='mb-2'>
            <button
              type='button'
              className='btn-search-action btn-search-reset w-100'
              onClick={handleClean}
            >
              <FontAwesomeIcon icon={faRedo} /> Limpiar
            </button>
          </Col>
          <Col xs={12} sm={6} md={3} lg={2} className='mb-2'>
            <button
              type='submit'
              className='btn-search-action btn-search-submit w-100'
              disabled={isObtainingData}
            >
              {isObtainingData ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} spin /> Buscando...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSearch} /> Buscar
                </>
              )}
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Searchbox;
